// @flow
import React, { Component } from 'react'
import styled, { type StyledComponent } from 'styled-components'
import postJson from '../../services/postJson'
import _ from 'lodash'
import matchesNotFloat from '../controls/FloatValueMatcher'
import SingleParamPopup from './SingleParamPopup'

const Link: StyledComponent<Object, any, any> = styled.a`
  display: inline-block;
  border-bottom: 1px dashed rgba(97, 184, 211, 0.5);
  text-decoration: none;
`

type Props = {|
  totalLimit: string,
  audienceId: number,
  onAudienceStateChange: Function
|}

type State = {|
  totalLimit: string,
  isOpen: boolean,
  errors: Array<string>
|}

export default class TotalLimitPopup extends Component<Props, State> {
  constructor(props: Props) {
    super(props)

    this.state = {
      totalLimit: props.totalLimit && props.totalLimit.replace(' ', ''),
      isOpen: false,
      errors: []
    }
  }

  render() {
    return (
      <SingleParamPopup
        inputName="audience_total_limit"
        isOpen={this.state.isOpen}
        value={this.state.totalLimit}
        errors={this.state.errors}
        withCurrency
        triggerBlock={this.renderTriggerBlock()}
        onChange={(e) => this.changed(e)}
        onDropdownChange={(isOpen) => this.dropdownChanged(isOpen)}
        onSubmit={() => this.submit()}
      />
    )
  }

  componentDidUpdate(prevProps: Props) {
    if (!_.isEqual(prevProps.totalLimit, this.props.totalLimit)) {
      this.setState({ totalLimit: this.props.totalLimit })
    }
  }

  dropdownChanged(isOpen: boolean) {
    if (!isOpen) this.setState({ totalLimit: this.props.totalLimit.replace(' ', '') })
    this.setState({ isOpen })
  }

  submit() {
    const { totalLimit } = this.state
    const { audienceId, onAudienceStateChange } = this.props
    const totalLimitUpdateUrl = `/api/v1/audiences/${audienceId}/total_limit_update`
    postJson(totalLimitUpdateUrl, { data: { total_limit: totalLimit } })
      .done((response) => {
        onAudienceStateChange([response.data.audience], audienceId)
        this.setState({ isOpen: false })
      })
      .fail((response: any) => {
        this.setState({ errors: response.responseJSON.message.total_limit })
      })
  }

  changed(e: Object) {
    const value = e.target.value

    if (matchesNotFloat(value)) return

    this.setState({ totalLimit: value, errors: [] })
  }

  renderTriggerBlock() {
    return (
      <Link
        href="#"
        className="offable"
        onClick={(event) => {
          event.preventDefault()
        }}
      >
        {this.props.totalLimit}
      </Link>
    )
  }
}
